// Bearbeitbares Regelwerk der KI-Schreibunterstützung (Ticket #418).
// Lesen darf das ganze Team, ändern nur Admins — durchgesetzt wird das in der Datenbank
// (RLS auf app_settings, Migration 2026-09-19). Die Rollenabfrage hier steuert nur, ob die
// Oberfläche den Stift zeigt; wer sie umgeht, läuft in die Policy.
import { supabase } from '../supabase/client';
import { PROMPT_KEY, STANDARD_REGELN } from './mailPromptStandard';

export { PROMPT_KEY, STANDARD_REGELN };

const ADMIN_ROLLEN = ['admin', 'super admin', 'master admin'];

/** Darf der angemeldete Benutzer das Regelwerk ändern? */
export async function darfPromptAendern(): Promise<boolean> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return false;
  const { data } = await supabase.from('profiles').select('role').eq('id', user.id).maybeSingle();
  return ADMIN_ROLLEN.includes(((data?.role as string) || '').toLowerCase());
}

/** Gespeichertes Regelwerk; nichts hinterlegt = Standard. */
export async function ladePrompt(): Promise<string> {
  const { data } = await supabase.from('app_settings').select('value').eq('key', PROMPT_KEY).maybeSingle();
  const v = data?.value;
  return typeof v === 'string' && v.trim() ? v : STANDARD_REGELN;
}

/**
 * Speichert das Regelwerk. Ein leerer Text setzt auf den Standard zurück (Zeile wird gelöscht),
 * damit spätere Änderungen am Standard auch ankommen.
 */
export async function speicherePrompt(text: string): Promise<void> {
  if (!text.trim()) {
    const { error } = await supabase.from('app_settings').delete().eq('key', PROMPT_KEY);
    if (error) throw error;
    return;
  }
  const { error } = await supabase.from('app_settings').upsert(
    { key: PROMPT_KEY, value: text.trim().slice(0, 6000), updated_at: new Date().toISOString() },
    { onConflict: 'key' },
  );
  if (error) throw error;
}
